export const accountLastName = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
